<template>
  <div class="tag-list w-full flex gap-[15px] flex-wrap py-4 flex-col" :class="{ small: sticky }">
    <Tags
      v-for="(tag, i) in filterTags"
      :key="tag.tag_id"
      v-model="searchForm[`tag_${tag.tag_id}`]"
      :hide="i == 2"
      :sticky="sticky"
      :parent-hovered="parentHovered"
      :data="tag"
      :multiple="false"
      @change="v => $emit('change', v)"
    />
    <TagsMore v-if="filterTags.length > 2" />
  </div>
</template>
<script lang="ts" setup>
import Tags from './tags.vue';
import TagsMore from './tags-more.vue';
import type { Tag } from '~/api/interface';

const props = defineProps<{
  sticky: boolean;
  parentHovered: boolean;
  modelValue: any;
  tags?: Tag[];
}>();

const emit = defineEmits(['change', 'update:modelValue']);

const enableGroups = ['industry', 'template_application_scene', 'department'];

const searchForm = reactive<any>({});

const filterTags = computed(() => {
  return props.tags?.filter(v => enableGroups.includes(v.outer_id!)) || [];
});

watch(
  () => props.modelValue,
  newValue => {
    Object.keys(newValue).forEach(key => {
      searchForm[key] = newValue[key];
    });
  },
  { immediate: true, deep: true },
);

watch(
  () => searchForm,
  (newValue, oldValue) => {
    const allKeys = [...new Set([...Object.keys(newValue), ...Object.keys(oldValue)])];

    const changedProps = allKeys.reduce((total, key) => {
      total[key] = newValue[key];
      return total;
    }, {} as any);
    emit('update:modelValue', changedProps);
  },
  { deep: true },
);
</script>
